export default "__VITE_ASSET__DyVIIQO3__"